import { Box, Divider, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography, useMediaQuery, useTheme, TableContainer } from '@mui/material'; 
import { IAco } from '../../../services/api/action-plan/Aco';
import { formatDateWhitoutHour } from '../../../services/helpers/helpers';

interface ISummaryAco {
    data: IAco
}

export const SummaryAco = ({ data }: ISummaryAco) => {

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box display={'flex'} flexDirection={'column'} gap={2}>
            <Box>
                <Typography><strong>Informações do último ACO</strong></Typography>
                <Box
                    sx={smDown ? { display: 'flex', flexDirection: 'column', gap: '1', justifyContent: 'center', alignContent: 'center' } : { display: 'flex', flexDirection: 'row', gap: '5px' }}
                >
                    <Typography>Data DCO : </Typography>
                    <Typography>{formatDateWhitoutHour(data.data_dco)}</Typography>
                </Box>
                <Box
                    sx={smDown ? { display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center' } : { display: 'flex', flexDirection: 'row', gap: '5px' }}
                >
                    <Typography>Data RCO : </Typography>
                    <Typography>{formatDateWhitoutHour(data.data_rco)}</Typography>
                </Box>
                <Box
                    sx={smDown ? { display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center' } : { display: 'flex', flexDirection: 'row', gap: '5px' }}
                >
                    <Typography>Data seminario : </Typography>
                    <Typography>{formatDateWhitoutHour(data.data_seminario)}</Typography>
                </Box>
                <Box
                    sx={smDown ? { display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center' } : { display: 'flex', flexDirection: 'row', gap: '5px' }}
                >
                    <Typography>Data simulado : </Typography>
                    <Typography>{formatDateWhitoutHour(data.data_simulado)}</Typography>
                </Box>
                <Box
                    sx={smDown ? { display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center' } : { display: 'flex', flexDirection: 'row', gap: '5px' }}
                >
                    <Typography>Empresa avaliadora : </Typography>
                    <Typography>{data.empresa_avaliadora}</Typography>
                </Box>
                <Box
                    sx={smDown ? { display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center' } : { display: 'flex', flexDirection: 'row', gap: '5px' }}
                >
                    <Typography>Responsável técnico : </Typography>
                    <Typography>{data.responsavel_tecnico}</Typography>
                </Box>
            </Box>
            <Divider />
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }} width={'100%'}> 
                <Typography><strong>Não conformidades</strong></Typography>
                <TableContainer component={Paper} sx={{ borderRadius: '25px', borderColor: theme.palette.primary.contrastText, flex: 1 }}>
                    <Table sx={{ minWidth: 650 }} aria-label="tabela de não conformidades"> 
                        <TableHead>
                            <TableRow>
                                <TableCell>Avaliação</TableCell>
                                <TableCell>Não conformidades</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.naoConformidades?.map((item, index) =>
                                <TableRow key={index}>
                                    <TableCell>{item.avaliacao}</TableCell>
                                    <TableCell>{item.nao_conformidade}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <Divider />
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }} width={'100%'}> 
                <Typography><strong>Recomendações</strong></Typography>
                <TableContainer component={Paper} sx={{ borderRadius: '25px', borderColor: theme.palette.primary.contrastText, flex: 1 }}>
                    <Table sx={{ minWidth: 650 }} aria-label="tabela de recomendações"> 
                        <TableHead>
                            <TableRow>
                                <TableCell>Prazo</TableCell>
                                <TableCell>Recomendações</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.recomendacoes?.map((item, index) =>
                                <TableRow key={index}>
                                    <TableCell>{item.prazo}</TableCell>
                                    <TableCell>{item.recomendacao}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
};